// extracted by mini-css-extract-plugin
export default {"wrap":"Or-z","melodyCategory":"Pr-z","fullWidth":"Qr-z","items":"Rr-z","featureCss":"Sr-z","disabled":"Tr-z","imgCss":"Ur-z"};